import * as m from "@/paraglide/messages";

// Error codes used in URL query params and runtime errors
export type AuthErrorCode =
  | "not_allowed"
  | "no_email"
  | "callback_failed"
  | "magic_link_expired"
  | "magic_link_invalid"
  | "otp_expired"
  | "send_failed"
  | "general";

export const AUTH_ERROR_CODES = {
  NOT_ALLOWED: "not_allowed",
  NO_EMAIL: "no_email",
  CALLBACK_FAILED: "callback_failed",
  MAGIC_LINK_EXPIRED: "magic_link_expired",
  MAGIC_LINK_INVALID: "magic_link_invalid",
  OTP_EXPIRED: "otp_expired",
  SEND_FAILED: "send_failed",
  GENERAL: "general",
} as const;

export function getAuthErrorMessage(errorCode: string): string {
  const errorMessages: Record<string, () => string> = {
    not_allowed: m.auth_error_not_allowed,
    no_email: m.auth_error_no_email,
    callback_failed: m.auth_error_callback_failed,
    magic_link_expired: m.auth_error_link_expired,
    magic_link_invalid: m.auth_error_link_invalid,
    otp_expired: m.auth_error_otp_expired,
    send_failed: m.form_error_send_failed,
    general: m.form_error_general,
  };
  return errorMessages[errorCode]?.() ?? errorCode;
}
